export default function (id) { 
  return `query GetIQuote {
    getIQuote(crmLeadAccessToken: "${id}") {
      id
      chosenQuoteId
      locale
      contact {
        address {
          city
          street
          postalCode
          houseNumber
          houseNumberAddition
        }
        email
        firstName
        lastName
      }
      orderPlaced
      company {
        name
        billingName
        email
        collectorId
        address {
          city
          street
          postalCode
          houseNumber
          houseNumberAddition
        }
      }
      viewableUntil
      quotes {
        termsAndConditions {
          pdfUrl  
          type
        }
        detailOverview {
          energyPrice
          energyGenerated
          monthlyPayment
          
        }
        id
        items {
          name {
            en
            fr
            nl
          }
          quantity
          category
        }
      }
    }
  }`
}
